module.exports = __webpack_public_path__ + "img/award.5bb35b4.png";